var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165286",
    "data-name": "Group 165286",
    transform: "translate(-7273.243 -20869.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(7273.243 20869.242)",
    fill: "none",
    stroke: "#0c4523",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic-check",
    transform: "translate(7294.642 20903.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M82.992,69.311l-45.1,43.61a8.767,8.767,0,0,1-12.1,0L2.505,90.406a8.082,8.082,0,0,1,0-11.7,8.764,8.764,0,0,1,12.1,0L31.84,95.37l39.05-37.76a8.766,8.766,0,0,1,12.1,0A8.085,8.085,0,0,1,82.992,69.311Z",
    transform: "translate(0 -55.188)",
    fill: "#0c4523"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCheckCircle);
export default __webpack_public_path__ + "static/media/group-check-circle.c750bef546492ecdb502799cc13cbbc2.svg";
export { ForwardRef as ReactComponent };